export default "__VITE_ASSET__9b1971b6__"